export class RiskUtils {

    static get TYPES () {

        return {
            DISEASE: 'DISEASE',
            INSECT: 'INSECT',
            LODGING: 'LODGING',
            NUTRITION: 'NUTRITION',
            GROWTH_STAGE: 'GROWTH_STAGE',
            HARVEST: 'HARVEST',
            WEED: 'WEED',
            ABIOTIC: 'ABIOTIC',
            NON_TIMING: 'NON_TIMING'
        };
    }
}


// WEBPACK FOOTER //
// ./shared/utils/RiskUtils.js